import { User, Headset } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type SimulatorRole = 'user' | 'assistant';

export const ROLE_META: Record<SimulatorRole, { label: string; align: 'left' | 'right'; icon: LucideIcon }> = {
  user: { label: 'Customer', align: 'left', icon: User },
  assistant: { label: 'Agent', align: 'right', icon: Headset },
};

export const otherRole = (role: SimulatorRole): SimulatorRole => (role === 'user' ? 'assistant' : 'user');
